import React, { useState, useEffect } from 'react';
import am5geodata_worldLow from '@amcharts/amcharts5-geodata/worldLow';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5 from '@amcharts/amcharts5';
import * as am5map from '@amcharts/amcharts5/map';
import './styles.css';

const Globe = (props) => {
	useEffect(() => {
		const root = am5.Root.new('chartdiv');

		// Set themes
		// https://www.amcharts.com/docs/v5/concepts/themes/
		root.setThemes([
			am5themes_Animated.new(root),
		]);

		// Create the map chart
		// https://www.amcharts.com/docs/v5/charts/map-chart/
		const chart = root.container.children.push(am5map.MapChart.new(root, {
			panX: 'rotateX',
			panY: 'rotateY',
			wheelX: 'none',
			wheelY: 'none',
			projection: am5map.geoOrthographic(),
			paddingBottom: 20,
			paddingTop: 20,
			paddingLeft: 20,
			paddingRight: 20,
		}));

		// Create series for background fill
		// https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon

		const backgroundSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {}));
		backgroundSeries.mapPolygons.template.setAll({
			fill: '#fafafa',
			// fillOpacity: 0.4,
			strokeOpacity: 0.5,
		});
		backgroundSeries.data.push({
			geometry: am5map.getGeoRectangle(90, 180, -90, -180),
		});

		// Create main polygon series for countries
		// https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
		const polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {
			geoJSON: am5geodata_worldLow,
			fill: '#d9d9d9',
			fillOpacity: 1,
		}));

		polygonSeries.mapPolygons.template.setAll({
			tooltipText: '{name}',
			toggleKey: 'active',
			interactive: true,
		});

		polygonSeries.mapPolygons.template.states.create('hover', {
			fill: root.interfaceColors.get('primaryButtonHover'),
		});

		// Create graticule series
		// https://www.amcharts.com/docs/v5/charts/map-chart/graticule-series/

		// Rotate animation
		chart.animate({
			key: 'rotationX',
			from: 0,
			to: 360,
			duration: 30000,
			loops: Infinity,
		});

		// Make stuff animate on load
		chart.appear(1000, 100);
		return () => root.dispose();
	}, []);

	return (
		<div className="globe" id="chartdiv" />
	);
};

export default Globe;
